import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { Row, ListGroupItem, Input } from "reactstrap";
import Select from "react-select";
import generateAction from "../../../../utils/action-helpers";
import { CLIENT } from "../../../../state/actions";
import RadioButton from "../../../ui/custom-radio";
import { Error } from "../../../ui/toaster";

const ProposalClientSearch = ({
  isSelected,
  selectedClient,
  select,
  index,
  moreThanOneProposal
}) => {
  const { searchResults, error } = useSelector(state => state.clients);
  const [searchSap, setSearchSap] = useState(selectedClient ? selectedClient.value : "");
  const [searchName, setSearchName] = useState(selectedClient ? selectedClient.label : "");
  const [searchValue, setSearchValue] = useState(selectedClient || null);
  const [showError, setShowError] = useState(false);
  const dispatch = useDispatch();
  const setClient = selected => dispatch(generateAction(CLIENT.SET_CLIENT, selected));
  useEffect(() => {
    if (searchValue && searchValue.value) {
      setSearchSap(searchValue.value);
      setSearchName(searchValue.label);
    } else {
      setSearchSap("");
      setSearchName("");
    }
    if (searchValue && selectedClient && searchValue.value !== selectedClient.value && isSelected) {
      setClient(searchValue);
      select(searchValue);
    }
    // No añadimos funciones al as dependencias
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, setSearchSap, setSearchName, selectedClient, isSelected]);
  useEffect(() => setShowError(error), [error]);
  useEffect(() => {
    let timeout = 0;
    if (searchName) {
      timeout = setTimeout(() => {
        dispatch(generateAction(CLIENT.FETCH, { name: searchName, sapCode: "" }));
      }, 500);
    }
    return () => clearTimeout(timeout);
  }, [dispatch, searchName]);

  useEffect(() => {
    let timeout = 0;
    if (searchSap) {
      timeout = setTimeout(() => {
        dispatch(generateAction(CLIENT.FETCH, { name: "", sapCode: searchSap }));
      }, 500);
    }
    return () => clearTimeout(timeout);
  }, [dispatch, searchSap]);
  useEffect(() => {
    if (searchResults && searchResults.length === 1) {
      const selectedValue = {
        value: searchResults[0].tercero,
        label: searchResults[0].name
      };
      setSearchValue(selectedValue);
    }
  }, [setSearchValue, searchResults]);

  const options = searchResults.map(x => {
    return {
      value: x.tercero,
      label: x.name
    };
  });
  const placeHolder = "Cód. SAP";
  return (
    <ListGroupItem key="proposal_search_custom" active={isSelected}>
      <Row className="d-flex align-items-center">
        <div className="col-1">
          <span className={`level-circle ${isSelected ? "selected" : ""}`}>
            <span>{index + 1}</span>
          </span>
        </div>
        <div className="col-3">
          <Row className="d-flex align-items-center justify-content-between">
            <Input
              placeholder={`${placeHolder}       \ue99a `}
              type="text"
              className="client-search-input no-border-radius-right"
              value={searchSap}
              onChange={event => setSearchSap(event.target.value)}
            />
          </Row>
        </div>
        <div className="col-6 level-literal client-search-select">
          <Select
            styles={{
              control: provided => ({
                ...provided,
                borderRadius: "0 .25rem .25rem 0 !important"
              })
            }}
            placeholder="Nombre del código"
            isClearable
            onInputChange={e => setSearchName(e)}
            onChange={e => {
              setSearchValue(e);
              if (e != null && isSelected) {
                setClient(e);
                select(e);
              }
            }}
            noOptionsMessage={() => "Introduzca un nombre o tercero para realizar la búsqueda"}
            value={searchValue}
            options={options}
            isSearchable
          />
        </div>
        <div className="col-1">
          <RadioButton
            isSelected={isSelected && moreThanOneProposal}
            tooltipPosition="left"
            tooltipText={
              // eslint-disable-next-line no-nested-ternary
              isSelected && moreThanOneProposal
                ? "Propuesta seleccionada para conciliar"
                : !searchSap
                ? "Para seleccionar esta opción deberá de introducir un tercero"
                : "Ver esta propuesta"
            }
            onChange={() => {
              setClient(searchValue);
              select(searchValue);
            }}
            disabled={!searchSap}
          />
        </div>
      </Row>
      <Error
        id="clientSearchError"
        visible={showError}
        onClose={() => setShowError(false)}
        title="Error al buscar terceros"
        text="Se ha producido un error en la búsqueda con los datos indicados."
      />
    </ListGroupItem>
  );
};

ProposalClientSearch.propTypes = {
  index: PropTypes.number,
  isSelected: PropTypes.bool,
  selectedClient: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  }),
  select: PropTypes.func,
  moreThanOneProposal: PropTypes.bool
};
ProposalClientSearch.defaultProps = {
  index: 1,
  isSelected: false,
  selectedClient: {
    value: "",
    label: ""
  },
  select: () => {},
  moreThanOneProposal: false
};

export default ProposalClientSearch;
